import Body from './Body';

const Edit = () => {
  return (
    <>
      <Body />
    </>
  );
};
export default Edit;
